const formatArea = (num, extra = "m²") => {
  const area = num.toLocaleString() + extra;

  return area;
};

export { formatArea };
